module.exports = __webpack_public_path__ + "img/1.ec0faf24.png";